import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TemplateService } from '../../services';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'hdw-footer',
  templateUrl: './hdw-footer.component.html',
  styleUrls: ['./hdw-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HdwFooterComponent implements OnInit {
  headerHtml: SafeHtml = '';
  constructor(
    private templateService: TemplateService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.templateService.getFooterHtml().subscribe({
      next: html => {
        if (html.startsWith('"') && html.endsWith('"')) {
          html = html.slice(1, -1);
        }
        // unescape quotes
        html = html.replace(/\\"/g, '"');
        // optional: unescape newlines
        html = html.replace(/\\n/g, '');
        this.headerHtml = this.sanitizer.bypassSecurityTrustHtml(html);
      },
      error: err => {
        console.error('Failed to load header HTML', err);
      }
    });
  }
}
